import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import WishlistActions from "../../../../redux/flone/wishlist/actions";
import ProductGridListSingle from "../../../components/product/ProductGridListSingle";

const cookies = new Cookies();
const { addToWishlist } = WishlistActions;

const ProductGridList = ({
  products,
  addToWishlist,
  sliderClassName,
  spaceBottomClass,
  addToCart,
  currency,
  cartItems,
  wishlistItems,
  compareItems,
  setIsQRScannerOpen,
  setSelectedProduct,
}) => (
  <>
    {products.map((product) => (
      <ProductGridListSingle
        key={product._id}
        sliderClassName={sliderClassName}
        spaceBottomClass={spaceBottomClass}
        product={product}
        currency={currency}
        addToCart={addToCart}
        addToWishlist={addToWishlist}
        cartItem={
          cartItems.items &&
          cartItems.items.find(({ product: { _id } }) => _id === product._id)
        }
        wishlistItem={
          wishlistItems &&
          wishlistItems.find(
            (wishlistItem) => wishlistItem?._id === product._id
          )
        }
        compareItem={
          compareItems &&
          compareItems.find((compareItem) => compareItem._id === product._id)
        }
        setIsQRScannerOpen={setIsQRScannerOpen}
        setSelectedProduct={setSelectedProduct}
      />
    ))}
  </>
);

ProductGridList.propTypes = {
  addToWishlist: PropTypes.func,
  products: PropTypes.array,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  addToWishlist: (item, addToast) => {
    const token = cookies.get("token");
    if (!token) {
      addToast("Please login first!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    dispatch(addToWishlist(item, addToast, token));
  },
});

export default connect(mapDispatchToProps)(ProductGridList);
